import React, { useState } from "react";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList } from "../../../../components/Links";
import UserAvatar from "../../../../components/UserAvatar";
import { useTheme, useThemeUpdate } from "../../../provider/Theme";
import { useAuth } from "../../../../Auth/auth";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../images/favicon.png"
const User = () => {
  const theme = useTheme();
  const themeUpdate = useThemeUpdate();
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);
  const navigate = useNavigate();
  const auth = useAuth();
  const handleLogout = () => {
    auth.logout()
    navigate('/admin')
  }
  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <div className="user-avatar bg-primary">
            <span>{auth.admin.first_name[0] + auth.admin.last_name[0]}</span>
          </div>
          <div className="user-info d-none d-md-block">
            <div className="user-status">Admin</div>
            <div className="user-name dropdown-indicator">{auth.admin.first_name + " " + auth.admin.last_name}</div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar bg-primary">
              <span>{auth.admin.first_name[0] + auth.admin.last_name[0]}</span>
            </div>
            <div className="user-info">
              <span className="lead-text">{auth.admin.first_name + " " + auth.admin.last_name}</span>
              <span className="sub-text">{auth.admin.email}</span>
            </div>
          </div>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <li>
              <a className={`dark-switch ${theme.skin === 'dark' ? 'active' : ''}`} href=""
                onClick={(ev) => {
                  ev.preventDefault();
                  themeUpdate.skin(theme.skin === 'dark' ? 'light' : 'dark');
                }}>
                {theme.skin === 'dark' ?
                  <><em className="icon ni ni-sun"></em><span>Light Mode</span></>
                  :
                  <><em className="icon ni ni-moon"></em><span>Dark Mode</span></>
                }
              </a>
            </li>
          </LinkList>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <a onClick={handleLogout} href="">
              <Icon name="signout"></Icon>
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;